import { Component, Prop, h, Element, State, Host, Event, EventEmitter } from '@stencil/core';
import { FormValue, Row, RowValue } from './types';
import { v4 as uuidv4 } from 'uuid';
import debounce from 'debounce';
import { minus, plus } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-multiple-input',
  styleUrl: 'pn-multiple-input.scss',
})
export class PnMultipleInput {
  @Element() hostElement: Element;
  pnSlotElement: HTMLElement = null;

  @Prop() label: string = null;
  @Prop() placeholder: string = null;
  @Prop() addRowButtonText: string = null;

  @State() rowData: Row[] = [];

  private _formValues: FormValue[] = [];

  @Event() allFormValues: EventEmitter<string>;

  componentWillLoad() {
    const elemtnId = this.generateUniqueId();
    const newRow: Row = { id: elemtnId, input: '' };
    this.rowData = [...this.rowData, newRow];
  }

  componentDidLoad() {
    this.addEventHandlers();
  }

  componentDidUpdate() {
    this.addEventHandlers();
  }

  addEventHandlers() {
    const rows = this.pnSlotElement.querySelectorAll('pn-marketweb-input');

    rows.forEach(element => {
      element.addEventListener('keyup', debounce(this.handleInput.bind(this), 500));
    });
  }

  generateUniqueId() {
    return uuidv4();
  }

  deleteRow(indexToRemove) {
    if (indexToRemove < 0) {
      return;
    }

    this.rowData.splice(indexToRemove, 1);
    this.rowData = [...this.rowData];
    this.emitValues();
  }

  addRow() {
    const newRow: Row = { id: this.generateUniqueId(), input: '' };
    this.rowData = [...this.rowData, newRow];
    this.emitValues();
  }

  handleInput(e) {
    const target = e.target;
    const inputElm = target.closest('pn-marketweb-input');

    if (!inputElm) {
      return;
    }

    const inputElmId = inputElm.id;
    const value = target.value;
    const index = this.rowData.findIndex(item => item.id === inputElmId);

    if (index < 0) {
      return;
    }

    this.rowData[index] = {
      ...this.rowData[index],
      input: value,
    };

    this.emitValues();
  }

  emitValues() {
    this._formValues = [];
    const label = this.label ? this.label : 'InputField';
    this.rowData.forEach(item => {
      const rowValue: FormValue = { row: [] };
      if (item.input) {
        const dropDownValue: RowValue = { name: label, value: item.input };
        rowValue.row.push(dropDownValue);
      }

      if (rowValue.row.length === 1) {
        this._formValues.push(rowValue);
      }
    });

    if (this._formValues.length === this.rowData.length) {
      const valueJsonString = JSON.stringify(this._formValues);
      this.allFormValues.emit(valueJsonString);
    } else {
      this.allFormValues.emit('');
    }
  }

  render() {
    return (
      <Host>
        <div ref={el => (this.pnSlotElement = el as HTMLElement)} class="multiple-input-slot">
          {this.rowData?.map((data, i) => {
            return (
              <div class="multiple-input-generated-row">
                <pn-marketweb-input label={this.label} type="text" placeholder={this.placeholder} value={data.input} id={data.id}></pn-marketweb-input>
                {i > 0 ? (
                  <pn-button
                    arialabel="Delete"
                    icon={minus}
                    appearance="warning"
                    onClick={() => {
                      this.deleteRow(i);
                    }}
                    index={i}
                    id={data.id}
                  >
                    Delete
                  </pn-button>
                ) : null}
              </div>
            );
          })}
        </div>
        <dvi class="multiple-input-row">
          <pn-button
            tooltip={this.addRowButtonText ? this.addRowButtonText : null}
            left-icon="true"
            arialabel="Add"
            icon={plus}
            appearance="light"
            variant="borderless"
            class="connected-dropdown__button-right"
            onClick={() => {
              this.addRow();
            }}
          >
            {this.addRowButtonText}
          </pn-button>
        </dvi>
      </Host>
    );
  }
}
